// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4629":"b90104b0","6366":"d9f12400","8658":"212475e3"}[chunkId] + ".chunk.css";
};